import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import { useCompanyPageStore } from "../../../../../store/companyPageStore";
import {
  SpendQueryType,
  useCompanySpend,
} from "../../../hooks/useCompanySpend";
import { SpendList } from "./ITSpendBreakdown/SpendList";
import { SearchToggle } from "@/components/ui/SearchToggle";
import { useSpendBreakdown } from "./ITSpendBreakdown/hooks/useSpendBreakdown";
import {
  SpendCardBody,
  SpendCardTitle,
} from "./ITSpendBreakdown/SpendCardParts";

interface SpendBreakdownCardProps {
  title: string;
  testIdPrefix: string;
  queryType: SpendQueryType.BY_CATEGORY | SpendQueryType.AI_BY_CATEGORY;
  caption?: string;
  emptyMessage?: string;
  rootName?: string;
}

export const SpendBreakdownCard = ({
  title,
  testIdPrefix,
  queryType,
  caption,
  emptyMessage,
  rootName,
}: SpendBreakdownCardProps) => {
  const company = useCompanyPageStore((state) => state.company);

  const { data, loading, error } = useCompanySpend({
    companyId: company?.hgId,
    queryType,
    per: 1000,
  });

  const {
    searchTerm,
    handleSearchChange,
    filteredData,
    totalValue,
    expandedItems,
    handleToggleExpand,
  } = useSpendBreakdown(data?.data);

  return (
    <Card
      data-testid={`${testIdPrefix}-title`}
      sx={{ p: 3, height: 440, display: "flex", flexDirection: "column" }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        mb={2}
      >
        <SpendCardTitle
          title={title}
          caption={caption}
          testId={`${testIdPrefix}-caption`}
        />

        <SearchToggle
          searchTerm={searchTerm}
          onSearchChange={handleSearchChange}
          placeholder="Search categories"
        />
      </Stack>

      <SpendCardBody
        loading={loading || !company}
        error={Boolean(error)}
        emptyMessage={emptyMessage}
        rows={data?.data}
        rootName={rootName}
        testIdPrefix={testIdPrefix}
      >
        <SpendList
          hierarchicalData={filteredData}
          totalValue={totalValue}
          expandedItems={expandedItems}
          onToggleExpand={handleToggleExpand}
        />
      </SpendCardBody>
    </Card>
  );
};
